(function () {
  function unveil(img) {
    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
      window.lazySizes.loader.unveil(img);
      return;
    }

    var dataSrc = img.getAttribute('data-src');
    if (dataSrc) img.src = dataSrc;

    var dataSrcset = img.getAttribute('data-srcset');
    if (dataSrcset) img.setAttribute('srcset', dataSrcset);
  }

  function readDefaults(item, img) {
    var dataSrc = img.getAttribute('data-src');
    var current = img.currentSrc || img.src;

    return {
      dataSrc: dataSrc || current,
      dataSrcset: img.getAttribute('data-srcset') || '',
      dataSizes: img.getAttribute('data-sizes') || 'auto',
    };
  }

  function restoreDefault(img, defaults) {
    img.setAttribute('data-src', defaults.dataSrc);

    if (defaults.dataSrcset) {
      img.setAttribute('data-srcset', defaults.dataSrcset);
      img.setAttribute('data-sizes', defaults.dataSizes);
    } else {
      img.removeAttribute('data-srcset');
      img.removeAttribute('sizes');
    }

    img.src = defaults.dataSrc;
    img.classList.add('lazyload');
    img.classList.remove('lazyloaded');
    unveil(img);
  }

  function showAltColor(img, url) {
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-sizes');
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
    img.classList.remove('lazyload', 'lazyloaded');
  }

  function initSection(section) {
    if (!section || section.dataset.x60PucFeature5Init === '1') return;
    section.dataset.x60PucFeature5Init = '1';

    section.querySelectorAll('.new-common-featured-item').forEach(function (item) {
      var img = item.querySelector('.img-container img');
      if (!img) return;

      var defaults = readDefaults(item, img);
      item._x60PucFeature5Defaults = defaults;

      var colors = item.querySelectorAll('.x60-puc-feature5__color');

      colors.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();

          if (btn.classList.contains('is-active')) return;

          colors.forEach(function (other) {
            other.classList.remove('is-active');
            other.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          if (btn.getAttribute('data-use-default') === 'true') {
            restoreDefault(img, item._x60PucFeature5Defaults);
            return;
          }

          var url = btn.getAttribute('data-image');
          if (url) showAltColor(img, url);
        });
      });
    });
  }

  function boot() {
    document
      .querySelectorAll('.common-section-container.x60-puc-feature5')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
